import { render, staticRenderFns } from "./Orderreissue.vue?vue&type=template&id=e1b81bb6&scoped=true&"
import script from "./Orderreissue.vue?vue&type=script&lang=js&"
export * from "./Orderreissue.vue?vue&type=script&lang=js&"
import style0 from "./Orderreissue.vue?vue&type=style&index=0&id=e1b81bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b81bb6",
  null
  
)

export default component.exports